import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { environment } from 'src/environments/environment';

/**
 * JWT Interceptor
 *
 * @export
 * @class JwtInterceptor
 * @implements {HttpInterceptor}
 */
@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  /**
   * Creates an instance of JwtInterceptor.
   * @param {AuthService} authService
   * @memberof JwtInterceptor
   */
  constructor(private authService: AuthService) {}

  public apiUrl = environment.apiUrl;

  /**
   * Intercept current user and jwt
   *
   * @param {HttpRequest<any>} request
   * @param {HttpHandler} next
   * @return {*}  {Observable<HttpEvent<any>>}
   * @memberof JwtInterceptor
   */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available
    const currentUser = this.authService.user;
    const jwt = this.authService.jwt;

    if (currentUser && jwt && request.url !== this.apiUrl + '/auth/local') {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${jwt}`,
        },
      });
    }
    return next.handle(request)
      .pipe(
        tap((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            const newToken = event.headers.get('Authorization-New');
            if (newToken) {
              this.authService.updateToken(newToken);
            }
          }
        })
      );
  }
}
